// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__2rmxt","content":"styles_content__Uzs+l","loadingWrapper":"styles_loadingWrapper__jNomm","sidebar":"styles_sidebar__Ve+EI"};